/**
 * Shared from/to + Done row chrome for filter range editors (date or number).
 * Presentational only — callers own inputs, validation, and submit.
 */
import { Button } from "../../../../../../../../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../../../../../../../../components/inputs/button-variants";
import FontBody2 from "../../../../../../../../../../../../components/fonts/font-body2/font-body2";
import useDashboardTranslation from "../../../../../../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import "./rma-list-filter-range-row.scss";

export interface IRmaListFilterRangeRowProps {
    fromInput: React.ReactNode;
    toInput: React.ReactNode;
    canSubmit: boolean;
    onDone: () => void;
}

const RmaListFilterRangeRow: React.FC<IRmaListFilterRangeRowProps> = ({
    fromInput,
    toInput,
    canSubmit,
    onDone,
}) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";

    return (
        <div className="rma-list-filter-range-row">
            <div className="rma-list-filter-range-row__field">{fromInput}</div>
            <span className="rma-list-filter-range-row__to">
                <FontBody2>{getTranslation("TO", scope)}</FontBody2>
            </span>
            <div className="rma-list-filter-range-row__field">{toInput}</div>
            <div className="rma-list-filter-range-row__done">
                <Button
                    variant={BUTTON_VARIANTS.Secondary}
                    text={getTranslation("DONE", scope)}
                    disabled={!canSubmit}
                    onClick={onDone}
                />
            </div>
        </div>
    );
};

export default RmaListFilterRangeRow;
